/* --- global matchMedia: false */

'use strict';
var $ = require('jquery');
var circlr = require('circlr');
var util = require('../../../utils/util');
var ajax = require('../../../utils/ajax');
var carousel = require('../../../components/carousel');
var lazyload = require('../../../utils/lazyload');

import loadVideo from '../../../pages/product/video/youtube';
import {hideZoom, switchIndicator} from '../../../pages/product/util/image';
import {debounce} from '../../../components/custom-lodash';
import 'jquery-zoom';

/**
 * @description hides the product video overlay
 */
var hideProductVideo = function () {
    var $imageOverlay = $('#pdpMain .product-images-top .product-image-overlay');
    var $controlls360 = $('#pdpMain .product-images-top').find('.image-controlls .product-360');
    var $controllsZoom = $('#pdpMain .product-images-top').find('.image-controlls .product-zoom');

    if ($imageOverlay.is(':visible')) {
        $imageOverlay.hide();
        $imageOverlay.removeClass('loaded');
    }

    $controlls360.show();
    $controllsZoom.show();
};

/**
 * @description hides the 360 degree overlay
 */
var hide360 = function () {
    var $imageOverlay = $('#pdpMain .product-images-top .product-image-overlay');
    var $controlls360 = $('#pdpMain .product-images-top').find('.image-controlls .product-360');
    var $controllsZoom = $('#pdpMain .product-images-top').find('.image-controlls .product-zoom');

    if ($imageOverlay.is(':visible')) {
        $imageOverlay.hide();
        $imageOverlay.removeClass('loaded');
    }

    $controlls360.hide();
    $controllsZoom.show();
};

/**
 * @description opens zoom
 * @param img, target
 */
var showZoom = function ($triggerdImgZoom) {
    var $imgZoom = $triggerdImgZoom === undefined ? $('#pdpMain .main-image') : $triggerdImgZoom;
    var $target = $('#pdpMain .product-images-top').find('#zoom-overlay');
    var $overlayZoomImage = $target.find('.product-zoom-image');
    var hiresUrl;
    var magnification = 0.75;

    if (!$imgZoom.length) {
        // remove zoom
        $overlayZoomImage.trigger('zoom.destroy');
        return;
    }

    hiresUrl = $imgZoom.closest('a').attr('href');

    // use main image as fallback
    if (hiresUrl === undefined) {
        hiresUrl = $('.main-image .primary-image').attr('src');
        magnification = 2;
    }

    hideProductVideo();
    hide360();

    $overlayZoomImage.trigger('zoom.destroy');

    // exchange background zoom image with actual triggered zoom image
    $('.zoom-background-image').attr('src', hiresUrl);

    $target.show(400, function () {
        if (hiresUrl && hiresUrl !== 'null' && hiresUrl.indexOf('noimagelarge') === -1) {
            $overlayZoomImage.zoom({
                url: hiresUrl,
                magnify: magnification,
                callback: function () {
                    if (util.isFirefox()) {
                        $(this).trigger('mouseenter').trigger('mousemove');
                    }
                },
                onZoomIn: function () {
                    $('.zoom-background-image').hide();
                },
                onZoomOut: function () {
                    $('.zoom-background-image').show();
                    hideZoom();
                }
            });
        }
    });

    $('.product-zoom.zoom-out-link').removeClass('inactive');
    $('.product-zoom.zoom-in-link').addClass('inactive');

    // set addition close handler
    $('.product-zoom-image').on('click', function (e) {
        e.preventDefault();

        if ($target.is(':visible')) {
            hideZoom($target);
        }
    });

    $('.zoom-out-link')
        .not('.inactive')
        .on('click', function (e) {
            e.preventDefault();

            if ($target.is(':visible')) {
                hideZoom();
            }
        });
};

/**
 * @description Puts the product video in the overlay
 * @param {Object} video iFrame code
 */
var showProductVideo = function (atts) {
    var $zoomOverlay = $('#pdpMain .product-images-top').find('#zoom-overlay');
    var $imageOverlay = $('#pdpMain .product-images-top .product-image-overlay');
    var $controlls360 = $('#pdpMain .product-images-top').find('.image-controlls .product-360');
    var $controllsZoom = $('#pdpMain .product-images-top').find('.image-controlls .product-zoom');

    $imageOverlay.find('.product-image-overlay-content').html(atts.url);
    $imageOverlay.addClass('loaded');

    if ($zoomOverlay.is(':visible')) {
        hideZoom();
    }

    if (!$imageOverlay.is(':visible')) {
        $imageOverlay.show();
    }

    $controlls360.hide();
    $controllsZoom.hide();
};

/**
 * @description Puts the 360 degree product images  in the overlay
 * @param {string} the product number
 */
var show360 = function (pid) {
    var $zoomOverlay = $('#pdpMain .product-images-top').find('#zoom-overlay');
    var $imageOverlay = $('#pdpMain .product-images-top .product-image-overlay');
    var $imageOverlayContent = $imageOverlay.find('.product-image-overlay-content');
    var $controlls360 = $('#pdpMain .product-images-top').find('.image-controlls .product-360');
    var $controllsZoom = $('#pdpMain .product-images-top').find('.image-controlls .product-zoom');
    var $controllNext = $('#pdpMain .product-images-top').find('.image-controlls a.product-360-next');
    var $controllPrev = $('#pdpMain .product-images-top').find('.image-controlls a.product-360-previous');
    var url = '';

    // check if images are already loaded
    if ($imageOverlayContent.find('img.image-360').length) {
        $imageOverlay.addClass('loaded');

        if ($zoomOverlay.is(':visible')) {
            hideZoom();
        }

        if (!$imageOverlay.is(':visible')) {
            $imageOverlay.show();
        }

        $controlls360.show();
        $controllsZoom.hide();
    } else {
        // generate pipeline URL
        url = util.appendParamToURL(util.ajaxUrl(Urls.get360DegreeImages), 'pid', pid);

        ajax.load({
            url: url,
            target: $imageOverlayContent,
            callback: function () {
                var circlrContent = circlr($imageOverlayContent.find('.image-360-container').get(0))
                    .scroll(true)
                    .vertical(false)
                    .reverse(true);

                $imageOverlay.addClass('loaded');
                if ($zoomOverlay.is(':visible')) {
                    hideZoom();
                }

                if (!$imageOverlay.is(':visible')) {
                    $imageOverlay.show();
                }

                $controllNext.on('click', function (e) {
                    e.preventDefault();
                    circlrContent.prev();
                });

                $controllPrev.on('click', function (e) {
                    e.preventDefault();
                    circlrContent.next();
                });

                $controlls360.show();
                $controllsZoom.hide();
            }
        });
    }
};

/**
 * @description Initialize zoom function (desktop)
 */
var initProductZoom = function () {
    var $zoomImage = $('.product-image-zoom');
    var zoomSrc = $zoomImage.attr('href');
    var $controllsZoom = $('#pdpMain .product-images-top').find('.image-controlls .product-zoom');

    // keep magnification 1 as long we use pdpzoom image size in transformobject in
    // productimages.isml and productthumbnails-carousel-include-2.isml, target resolution 1500x1500px
    var magnification = 1;

    // use main image as fallback
    if (zoomSrc === undefined) {
        zoomSrc = $zoomImage.children('.main-image').attr('src');
        magnification = 2;
    }

    $zoomImage.on('click', function (event) {
        event.preventDefault();
    });

    $controllsZoom.on('click', function (event) {
        event.preventDefault();
    });

    $zoomImage.zoom({
        url: zoomSrc,
        magnify: magnification,
        callback: function () {
            $controllsZoom.show();
        },
        onZoomIn: function () {
            $controllsZoom.hide();
        },
        onZoomOut: function () {
            $controllsZoom.show();
        },
        touch: false
    });
};

/**
 * @description Set zoom image and zoom handler for PDP images
 * @param img
 */
var initProductZoomMobile = function () {
    var $zoomOverlay = $('#pdpMain .product-images-top').find('#zoom-overlay');
    var $mainImage = $('#pdpMain .product-images-top').find('img.main-image');

    if ($zoomOverlay === undefined || $mainImage === undefined || $mainImage.hasClass('no-image')) {
        $('a.product-zoom').remove();
        return false;
    }

    // resize zoom overlay for desktop to cover top content section
    // $zoomOverlay.width($topContent.outerWidth());
    // $zoomOverlay.height($topContent.outerHeight());

    $('.product-image .main-image').unbind();

    var touchmoved = false;
    $('.product-image .main-image')
        .on('touchend', function (e) {
            e.preventDefault();

            if (!touchmoved) {
                if ($(this).hasClass('slider-image')) {
                    if (!$zoomOverlay.is(':visible')) {
                        showZoom($(this));
                    } else {
                        hideZoom();
                    }
                } else if (!$zoomOverlay.is(':visible')) {
                    showZoom();
                } else {
                    hideZoom();
                }
            }
        })
        .on('touchmove', function () {
            touchmoved = true;
        })
        .on('touchstart', function () {
            touchmoved = false;
        });

    $('.pdp-slider .bubble').on('touchstart', function () {
        hideZoom();
    });

    $('.zoom-in-link')
        .not('.inactive')
        .on('click', function (e) {
            e.preventDefault();

            if (!$zoomOverlay.is(':visible')) {
                showZoom();
            }
        });

    $('.carousel-container')
        .find('a.thumbnail-link')
        .on('click', function () {
            hideZoom();
        });

    $('.carousel-container').on('keydown', 'a.thumbnail-link', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).find('.productthumbnail').trigger('click');
        }
    });
};

/**
 * @description Request all product images asynchronously and init slider on them
 * @param {string} the product number
 */
var initMobileImageslider = function (pid) {
    var currentPid = pid || $('#pdpMain .product-primary-image').data('pid');
    var currentUrl = $('#pdpMain .product-primary-image').data('image-url');
    var url = currentUrl
        ? util.ajaxUrl(currentUrl)
        : util.appendParamToURL(util.ajaxUrl(Urls.getSliderImages), 'pid', currentPid);
    var $sliderContainer = $('#pdpMain .product-images-top').find('.main-image-slider .slider-images');
    var $defImageContainer = $('#pdpMain .product-images-top').find('.main-image-slider .default-image');
    ajax.load({
        url: url,
        target: $sliderContainer,
        callback: function () {
            carousel.init();
            initProductZoomMobile();
            $sliderContainer.show();
            $defImageContainer.hide();
            lazyload.init();

            var ytVideo = document.getElementById('yt-video');

            if (ytVideo) {
                var player;
                var videoId = $(ytVideo).find('.product-image-overlay-content').data('yt-id');

                if (!window.YT || !window.YT.Player) {
                    window.onYouTubeIframeAPIReady = function () {
                        new window.YT.Player('yt-' + videoId, {
                            height: '333',
                            width: '500',
                            videoId: videoId,
                            playerVars: {
                                autoplay: 1,
                                controls: 0,
                                loop: 1,
                                rel: 0,
                                modestbranding: 1,
                                enablejsapi: 1,
                                playsinline: 1,
                                origin: document.domain,
                                showinfo: 0
                            },
                            events: {
                                onReady: onPlayerReady
                            }
                        });
                    };
                } else {
                    new window.YT.Player('yt-' + videoId, {
                        height: '333',
                        width: '500',
                        videoId: videoId,
                        playerVars: {
                            autoplay: 1,
                            controls: 0,
                            loop: 1,
                            rel: 0,
                            modestbranding: 1,
                            enablejsapi: 1,
                            playsinline: 1,
                            origin: document.domain,
                            showinfo: 0
                        },
                        events: {
                            onReady: onPlayerReady
                        }
                    });
                }

                function toggleVideo(e) {
                    if (player.getPlayerState() === 1) {
                        player.pauseVideo();
                    } else {
                        player.playVideo();
                    }
                }

                function onPlayerReady(event) {
                    player = event.target;
                }

                ytVideo.addEventListener('click', toggleVideo, false);
            }
        }
    });
};

/**
 * @description set handler for 360 degree images
 * @param
 */
var init360 = function () {
    hide360();

    $('#pdpMain').on('click', '.product-360-link', function (e) {
        var $imageOverlay = $('#pdpMain .product-images-top .product-image-overlay');
        var $imageOverlayContent = $imageOverlay.find('.product-image-overlay-content');
        var productId = $(this).data('prodid');
        e.preventDefault();

        if ($imageOverlayContent.is(':visible')) {
            hide360();
            switchIndicator($(this).closest('li').next('li').find('a'));
        } else {
            // load 360 degree pictures and open dialog
            show360(productId);
            switchIndicator($(this));
        }
    });
};

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
var setMainImage = function (atts) {
    if (!atts) {
        return;
    }

    $('#pdpMain .primary-image:not(.slider-main-image,.slider-image,.variant-image)').attr({
        src: atts.url,
        alt: atts.alt,
        title: atts.title
    });
};

/**
 * @description Sets the zoom image attributes
 * @param {Object} atts Object with url, alt, title, hires and zoom properties
 */
var setZoomImage = function (atts) {
    if (!atts) {
        return;
    }

    var $overlayZoomImage = $('#pdpMain .product-image-container').find('.product-zoom-image');
    var $zoomImage = $overlayZoomImage.find('img.zoom-image');
    var $mainImage = $('#pdpMain .product-images-top').find('img.main-image');

    $mainImage.trigger('zoom.destroy');

    const $productZoom = $('.product-image-zoom');
    if ($productZoom) {
        $productZoom.attr('href', atts.hires);
    }

    if ($zoomImage !== undefined && $zoomImage.lenght !== 0) {
        $zoomImage.attr({
            src: atts.hires,
            alt: atts.alt,
            title: atts.title
        });

        initProductZoom();
    }
};

/**
 * @description Sets the main image, the href for the surrounding <a> tag and also the zoom image
 * @param {Object} atts Object with url, alt, title, hires and zoom properties
 */
var setProductImages = function (atts) {
    setMainImage(atts);
    setZoomImage(atts);
};

/**
 * @description Replaces the images in the image container, for eg. when a different color was clicked.
 */
var replaceImages = function () {
    var $newImages = $('#update-images');
    var $imageContainer = $('#pdpMain .product-image-container');
    if (!$newImages.length) {
        return;
    }

    $imageContainer.html($newImages.html());
    $newImages.remove();
    //initThumbCarousel();
    initMobileImageslider();
    initProductZoom();
    init360();
    loadVideo();
};

// Remove campaign-image from carousel
function removeCampaignImage() {
    var widthsize = $(window).width();
    if (widthsize > 1023) {
        $('.productthumbnail.campaign-image').parent().parent().remove();
    }
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 */

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 */
module.exports = function () {
    initProductZoom();

    // handle product thumbnail click event
    $('#pdpMain').on('click', '.productthumbnail', function () {
        switchIndicator($(this));
        hideZoom();
        hideProductVideo();
        hide360();
        setProductImages($(this).data('lgimg'));
    });

    init360();
    initMobileImageslider($('#pdpMain .product-primary-image').data('pid'));
    removeCampaignImage();
    loadVideo();

    $(window).on(
        'resize orientationchange',
        debounce(function () {
            $('.product-image-slick').slick('resize');
        }, 100)
    );
    if (navigator.share) {
        $('body').on('click', '.share-button', function () {
            var sharingUrl = util.getSharingLink();
            navigator.share({
                title: document.title,
                url: sharingUrl
            });
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'shareIconClick',
                    ecomm_prodid: $('#pdpMain .product-primary-image').data('pid')
                });
            }
        });
    }
};
module.exports.initProductZoom = initProductZoom;
module.exports.setMainImage = setMainImage;
module.exports.replaceImages = replaceImages;
